export default "__VITE_ASSET__TSnGcffK__"